import React, { useEffect } from 'react'
import { useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import { Button, Toast } from '@ow/comps'

const BatchStatus = function () {
  const {
    currentStatus,
    selectedIds,
    setIsShowBatchOperate,
    isShowBatchOperate,
    setDataCheckDisabled,
  } = useTbViewStore((state) =>
    pick(state, [
      'currentStatus',
      'selectedIds',
      'setIsShowBatchOperate',
      'isShowBatchOperate',
      'setDataCheckDisabled',
    ])
  )
  useEffect(() => {
    setDataCheckDisabled(isShowBatchOperate)
  }, [isShowBatchOperate])

  return (
    <Button
      type="primary"
      onClick={() => {
        if (!currentStatus.length) {
          Toast.error({
            title: '请选择状态!',
          })
        } else if (currentStatus.length > 1) {
          Toast.error({
            title: '请选择一种状态!',
          })
        } else if (!selectedIds.length) {
          Toast.error({
            title: '请勾选数据!',
          })
        } else {
          setIsShowBatchOperate(true)
        }
      }}
    >
      批量操作
    </Button>
  )
}

export default BatchStatus
